import { css } from '@emotion/css'
import { zIndex, fontSize, borderRadius } from '../../styles'
import { colors } from '../../themes'
import { scrollGradient } from '../../utils/styleUtils'

const styles = {
  list: css({
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: zIndex.level8,
    fontSize: fontSize.small,
    color: colors.oxfordBlue,
    margin: 0,
    backgroundColor: colors.white,
    border: `1px solid ${colors.mystic}`,
    overflow: 'hidden',

    '& > * + *': {
      borderTop: `1px solid ${colors.catskillWhite}`,
    },
  }),

  body: css({
    maxHeight: 260,
    overflowY: 'auto',
    margin: 0,

    // Scroll gradient
    ...scrollGradient,

    '& > * + *': {
      borderTop: `1px solid ${colors.catskillWhite}`,
    },
  }),
}

export default styles

export const listPosition = position => {
  switch (position) {
    case 'top':
      return css({
        bottom: '100%',
        borderTopLeftRadius: borderRadius.default,
        borderTopRightRadius: borderRadius.default,
      })

    default:
      return css({
        top: '100%',
        borderBottomLeftRadius: borderRadius.default,
        borderBottomRightRadius: borderRadius.default,
      })
  }
}
